import posthog, { type PostHog } from "posthog-js";
import { posthogPublicHost, posthogPublicKey } from "./constants";

let swanPosthog: PostHog = posthog;

if (typeof window !== "undefined") {
	const instance = posthog.init(posthogPublicKey, { api_host: posthogPublicHost }, "swan");
	if (instance) {
		swanPosthog = instance;
	}
}

export default swanPosthog;
